module.exports = __webpack_public_path__ + "img/email.968e08ce.svg";